import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_LIST } from '../constants';
import { apiProvider } from '../api';

const filter = {
	OjId: null as number | null,
	MioPzn: null as number | null,
	SkladOzn: null as number | null,
	VyrobekndOzn: null as string | null,
	NdNr: null as string | null,
	EanCode: null as string | null,
	ZakazkaNr: null as number | null,
	MioPfx: null as string | null,
	MioNr: null as number | null,
	OdeslanePrp: null as boolean | null,
	NeodeslanePrp: null as boolean | null,
	VstupDatOd: null as Date | null,
	VstupDatDo: null as Date | null,
	Vyrazen: null as boolean | null,
	StatusDodNedodano: null as boolean | null,
	StatusDodCast: null as boolean | null,
	StatusDodDodano: null as boolean | null,
	StatusVydNevydano: null as boolean | null,
	StatusVydCast: null as boolean | null,
	StatusVydVyd: null as boolean | null,
};

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_LIST,
	dropdownList: {
		OjId: [],
		MioPzn: [],
		SkladOzn: [],
		VyrobekndOzn: [],
	},
	filter,
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
